// @flow
/* eslint-disable @typescript-eslint/no-use-before-define */
function parseCandidates(data, sheetOffsetForCandidates) {
  return data.rows
    .filter(candidate => candidate.id <= sheetOffsetForCandidates)
    .reduce((prev, curr) => {
      prev[curr.name] = {
        name: curr.name,
        fullName: curr.fullname,
        party: curr.party,
        image: curr.image,
        description: curr.description,
        portraitLink: curr.portraitlink,
        entries: {
          c1: {
            video: curr.entryc1,
            videoDescription: curr.entryc1videodescription,
            shortText: curr.entryc1shorttext,
            longText: curr.entryc1longtext,
            poster: curr.entryc1poster,
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c2: {
            video: curr.entryc2,
            videoDescription: curr.entryc2videodescription,
            shortText: curr.entryc2shorttext,
            longText: curr.entryc2longtext,
            poster: curr.entryc2poster,
            verdict: curr.verdictc2,
            stars: curr.verdictc2stars
          },
          c3: {
            video: curr.entryc3,
            videoDescription: curr.entryc3videodescription,
            shortText: curr.entryc3shorttext,
            longText: curr.entryc3longtext,
            poster: curr.entryc3poster,
            verdict: curr.verdictc3,
            stars: curr.verdictc3stars
          },
          c4: {
            video: curr.entryc4,
            videoDescription: curr.entryc4videodescription,
            shortText: curr.entryc4shorttext,
            longText: curr.entryc4longtext,
            poster: curr.entryc4poster,
            verdict: curr.verdictc4,
            stars: curr.verdictc4stars
          },
          c5: {
            video: curr.entryc5,
            videoDescription: curr.entryc5videodescription,
            shortText: curr.entryc5shorttext,
            longText: curr.entryc5longtext,
            poster: curr.entryc5poster,
            verdict: curr.verdictc5,
            stars: curr.verdictc5stars
          },
          c6: {
            video: curr.entryc6,
            videoDescription: curr.entryc6videodescription,
            shortText: curr.entryc6shorttext,
            longText: curr.entryc6longtext,
            poster: curr.entryc6poster,
            verdict: curr.verdictc6,
            stars: curr.verdictc6stars
          }
        }/*,
        verdicts: {
          c1: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c2: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c3: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c4: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c5: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          },
          c6: {
            verdict: curr.verdictc1,
            stars: curr.verdictc1stars
          }
        } */
      }
      return prev
    }, {})
}

function candidatesAsArray(candidates) {
  let asArray = []
  for (let c in candidates) {
    asArray.push(candidates[c])
  }
  return asArray
}

function parseChallenges(data, sheetOffsetForCandidates, currentChallengeCellId) {
  const challengeStates = getActiveSections(data, sheetOffsetForCandidates)
  const challengeTitles = getChallengeTitles(data, sheetOffsetForCandidates)
  const challengeExplainerTexts = getChallengeExplainerTexts(data, sheetOffsetForCandidates)
  const currentChallenge = getCurrentChallenge(data, currentChallengeCellId)

  return {
    challengeStates,
    challengeTitles,
    challengeExplainerTexts,
    currentChallenge
  }
}

function getActiveSections(data, sheetOffsetForCandidates) {
  // read active state of sections
  return data.rows
    .filter(d => d.id > sheetOffsetForCandidates)
    .reduce((prev, curr) => {
      prev[curr.id] = curr.active === 1
      return prev
    }, {})
}

function getChallengeTitles(data, sheetOffsetForCandidates) {
  return data.rows.filter(d => d.id > sheetOffsetForCandidates).map(r => r.sectiontitle)
}

function getCurrentChallenge(data, currentChallengeCellId) {
  return data.rows.find(
    entry => entry.id === currentChallengeCellId
  ).currentchallenge
}

function getChallengeExplainerTexts(data, sheetOffsetForCandidates) {
  return data.rows.filter(d => d.id > sheetOffsetForCandidates).map(r => r.sectionexplainertext)
}

function calculateScore(score:number, participants:number, juryScore:number): number {
  const juryWeight = 0.2
  const participantsWeight = 0.8

  const participantsAverage = score / participants

  const endScore = participantsAverage * participantsWeight + juryScore * juryWeight

  return endScore || juryScore
}

export { parseCandidates, candidatesAsArray, parseChallenges, calculateScore }
